import AuthUtil from '@/util/auth-util';
import {create} from 'apisauce';
import ApiAuth from './api-auth';

const Client = create({baseURL: undefined});

let refreshTokenPromise: Promise<any> | undefined;

Client.addRequestTransform((request: any) => {
    const user = AuthUtil.getCacheUserInfo();
    if (user?.tokens.access.token) {
        request.headers.Authorization = `Bearer ${user.tokens.access.token}`;
    }
    request.tokenSequence = user?.sequence || 0;
});

Client.addMonitor(async (response: any) => {
    if (response && response.status === 401 && !response.config?.ignore401) {
        if (response.config?.isRetry) {
            response.config.isRetry = false;
            return;
        }
        AuthUtil.setSliceUserInfo(undefined);
        AuthUtil.setStoreUserToken(undefined);
    }
});

Client.axiosInstance.interceptors.response.use(
    (response: any) => response,
    async (error: any) => {
        if (error?.response?.status !== 401) return error;
        const response = error.response;
        if (response.config?.ignore401) return error;
        if (response.config?.isRetry) return error;

        try {
            const user = AuthUtil.getCacheUserInfo();
            const token = user?.tokens.refresh.token;
            if (!token) return error;

            if (user.sequence !== response.config?.tokenSequence) {
                return Client.any({...response.config, isRetry: true});
            }

            if (!refreshTokenPromise) {
                refreshTokenPromise = new Promise(async (resolve) => {
                    try {
                        const res: any = await ApiAuth.refreshToken({token});
                        if (res?.data?.code === 0) {
                            const tokens = res.data.data;
                            AuthUtil.setStoreUserToken(tokens);
                            AuthUtil.setSliceUserInfo({tokens});
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    } catch (refreshError) {
                        resolve(false);
                    }
                    refreshTokenPromise = undefined;
                });
            }
            const success = await refreshTokenPromise.then();
            if (!success) return error;

            if (response.config) {
                return Client.any({...response.config, isRetry: true});
            }
            return error;
        } catch (newErr) {
            return error;
        }
    },
);

export default Client;
